module.exports = __webpack_public_path__ + "static/img/大暴雨.2ff776cb.svg";